<template>
<bim-row id="what-difference" class="services-lending__difference-container" justify="center">
  <bim-col class="services-lending__info-title" cols="12">В чем разница</bim-col>
  <bim-row justify="center">

    <!--Минусы-->
    <bim-col cols="12" lg="6" class="pr-0 d-flex flex-column">
      <h2 class="difference__title difference__minus">Самостоятельно</h2>
      <div class="d-flex flex-column difference__item-wrapper">
        <div v-for="diff_minus in difference_minus" :key="diff_minus" class="difference__minus difference__item">
          <div><img class="difference__item-image" src="/dist/assets/front_white/img/services_lending/deny-sales.svg" /></div>
          <div class="difference__item-text">{{ diff_minus }}</div>
        </div>
      </div>
    </bim-col>

    <!--Плюсы-->
    <bim-col cols="12" lg="6" class="pl-0 d-flex flex-column">
      <h2 class="difference__title difference__plus">Используя BIMLIB</h2>
      <div class="d-flex flex-column difference__item-wrapper">
        <div v-for="diff_plus in difference_plus" :key="diff_plus" class="difference__plus difference__item">
          <div><img class="difference__item-image" src="/dist/assets/front_white/img/services_lending/accept-sales.svg" /></div>
          <div class="difference__item-text">{{ diff_plus }}</div>
        </div>
      </div>
    </bim-col>

    <bim-col cols="12"><hr class="difference__delimiter"></bim-col>
    
  </bim-row>
</bim-row>
</template>

<script>
import bimRow from '@bimlib/components/bimRow'
import bimCol from '@bimlib/components/bimCol'

export default {
  name: "block-difference",
  components: {
    bimCol,
    bimRow
  },
  data() {
    return {
      difference_minus: [
        "Приходится тратить много времени на поиск строящихся объектов в нужном регионе",
        "Приходится искать контактную информацию, часть из которой хорошо спрятана",
        "Звонки «вхолодную» из-за недостатка данных о реальной проектной потребности"
      ],
      difference_plus: [
        "Данные предоставлены автоматически",
        "Снабдим контактной информацией",
        "Передадим данные для «теплых» звонков и диалога по существу"
      ]
    }
  }
}
</script>